/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  GRID: {
    ERROR_MISSING_MANDATORY_CONFIG: 'Die Konfiguration enthält keine API URL zum Abrufen von Befragungen!',
    ERROR_LOADING_SURVEYS: 'Beim Laden der Befragungen ist ein Fehler aufgetreten!',
    RELATED_DATA_NOT_AVAILABLE: 'Verknüpfte Daten nicht vorhanden!',
    CONFIG_ERROR: 'Konfigurationsfehler',
    SURVEYS: 'Befragungen',
    PATIENT_ID: 'PatNr.',
    CASE_NR: 'FallNr.',
    PATIENT: 'Patient',
    QUESTIONNAIRES: 'Fragebögen',
    HISTORY: 'Historie',
    OPTIONS: 'Optionen',
    CONTINUE_SURVEY: 'Befragung fortsetzen',
    RESTART_SURVEY: 'Befragung neu starten',
    RESUBMIT_SURVEY: 'Befragung erneut abgeben',
    EXPORT_SURVEY: 'Befragung exportieren',
    IMPORT: 'Importieren',
    CONFIRM_RESUBMIT: 'Möchten Sie die Befragung wirklich erneut abgeben?',
    ERROR_RESUBMITTING_SURVEY: 'Beim erneuten Abgeben der Befragung ist ein Fehler aufgetreten!',
    SUCCESS_RESUBMITTING_SURVEY: 'Die Befragung wurde erfolgreich erneut abgegeben.',
    ERROR_IMPORTING_SURVEY: 'Beim Import der Befragung ist ein Fehler aufgetreten!',
    SUCCESS_IMPORTING_SURVEY: 'Die Befragung wurde erfolgreich importiert.',
    ERROR_EXPORTING_SURVEY: 'Beim Export der Befragung ist ein Fehler aufgetreten!',
    STATUS: 'Status',
    STATUS_CREATED: 'Erstellt',
    STATUS_ASSIGNED: 'Zugewiesen',
    STATUS_SAVED: 'Zwischengespeichert',
    STATUS_SUBMITTED: 'Abgegeben',
    STATUS_SIGNED: 'Unterschrieben',
    STATUS_IMPORTED: 'Importiert',
    STATUS_CANCELED: 'Abgebrochen',
    STATUS_SKIPPED: 'Übersprungen',
    STATUS_EXPIRED: 'Abgelaufen',
    CREATED_AT: 'Erstellt am',
    UPDATED_AT: 'Bearbeitet am',
    ENTRIES: 'Einträge',
    ASSETS: 'Dateien',
    MR: 'Herr',
    MS: 'Frau',
    ID: 'Id',
    PSEUDONYMOUS: 'Pseudonym',
    ANONYMOUS: 'Anonym',
    USER: 'Benutzer',
    QUESTIONNAIRE_FILTER: 'Fragebogen',
    FROM: 'Von',
    TO: 'Bis'
  },
  HISTORY: {
    SURVEY_HISTORY: 'Historie der Befragung'
  }
};

